export default __webpack_public_path__ + "static/media/green_1.552779ed.png";